import styled from 'styled-components';
import { theme } from '../../theme';

export const TechSection = styled.section`
  background: ${theme.colors.bg};
  padding: 80px 0;
  overflow: hidden;
`;

export const TechShell = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: ${theme.breakpoints.md}) {
    padding: 0 1rem;
  }
`;

export const TechHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 360px);
  gap: 2rem;
  align-items: end;
  margin-bottom: 2.5rem;

  @media (max-width: ${theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const HeaderCopy = styled.div``;

export const LeadCard = styled.div`
  padding: 1.15rem 1.2rem;
  border-radius: 24px;
  border: 1px solid rgba(${theme.colors.primaryRgb}, 0.16);
  background: linear-gradient(180deg, rgba(${theme.colors.primaryRgb}, 0.1), rgba(8, 12, 18, 0.56));
`;

export const LeadLabel = styled.span`
  display: inline-flex;
  margin-bottom: 0.45rem;
  font-family: 'Space Grotesk', 'Manrope', sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${theme.colors.primaryLight};
`;

export const LeadTitle = styled.h3`
  margin-bottom: 0.45rem;
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: -0.04em;
  color: ${theme.colors.text};
`;

export const LeadText = styled.p`
  color: ${theme.colors.textMuted};
  font-size: 0.92rem;
  line-height: 1.7;
`;

export const GroupGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: ${theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
  }
`;

export const TechGroup = styled.article`
  display: grid;
  gap: 1rem;
  padding: 1.25rem;
  border-radius: 26px;
  border: 1px solid rgba(148, 163, 184, 0.12);
  background: linear-gradient(180deg, rgba(17, 25, 34, 0.96), rgba(11, 17, 23, 0.9));
`;

export const GroupTitle = styled.h3`
  margin-bottom: 0.35rem;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: -0.04em;
  color: ${theme.colors.text};
`;

export const GroupDesc = styled.p`
  color: ${theme.colors.textMuted};
  font-size: 0.9rem;
  line-height: 1.7;
`;

export const TechList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
`;

export const TechItem = styled.div<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 46px;
  padding: 0.7rem 0.85rem;
  background: rgba(8, 12, 18, 0.76);
  border: 1px solid rgba(148, 163, 184, 0.1);
  border-radius: 16px;
  transition: ${theme.transitions.default};
  cursor: default;

  svg {
    font-size: 1rem;
    color: ${theme.colors.textSecondary};
    opacity: 0.75;
    transition: ${theme.transitions.default};
  }

  span {
    font-size: 0.78rem;
    font-weight: 700;
    color: ${theme.colors.textMuted};
    text-align: center;
  }

  &:hover {
    border-color: ${({ $color }) => $color}50;
    background: ${({ $color }) => $color}0d;
    transform: translateY(-4px);
    box-shadow: 0 8px 24px ${({ $color }) => $color}20;

    svg {
      color: ${({ $color }) => $color};
      opacity: 1;
      transform: scale(1.15);
    }
    span { color: ${theme.colors.text}; }
  }
`;

export const SectionTag = styled.span`
  display: inline-block;
  padding: 0.3rem 0.85rem;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${theme.colors.primaryLight};
  background: rgba(${theme.colors.primaryRgb}, 0.1);
  border: 1px solid rgba(${theme.colors.primaryRgb}, 0.25);
  margin-bottom: 1rem;
`;

export const SectionTitle = styled.h2`
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  font-weight: 700;
  letter-spacing: -0.06em;
  color: ${theme.colors.text};
  margin-bottom: 1rem;

  span {
    background: ${theme.colors.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1rem;
  color: ${theme.colors.textMuted};
  max-width: 560px;
  margin: 0;
  line-height: 1.75;
`;
